import React from 'react';

export const ResumeBoxItem = ({label, value}) => {
  return (
    <>
      <span className="text-gray-400 text-nowrap">{label}</span>
      <span className="mb-2">
        <p className="mb-2">{value}</p>
      </span>
    </>
  );
};

ResumeBoxItem.propTypes = {}

ResumeBoxItem.defaultProps = {}

export default React.memo(ResumeBoxItem);